const TAPESTRY_TEMPLATE_SELECTOR =
  "#MainContent[data-template='product.merowen-wall-tapestries']";
const TAPESTRY_CONTACT_SELECTOR =
  '[data-merowen-tapestry-product-section-type="contact"]';
const TAPESTRY_CONTACT_INSTANCES = new WeakMap();

function markTapestryAssetsReady(root = document) {
  const templateRoot =
    root.matches?.(TAPESTRY_TEMPLATE_SELECTOR)
      ? root
      : root.querySelector?.(TAPESTRY_TEMPLATE_SELECTOR);

  if (templateRoot) {
    templateRoot.dataset.merowenTapestryProductAssets = 'ready';
  }
}

function initTapestryContact(root) {
  if (!root || TAPESTRY_CONTACT_INSTANCES.has(root)) return;

  const form = root.querySelector('[data-merowen-tapestry-product-contact-form]');
  const message = root.querySelector('[data-merowen-tapestry-product-contact-message]');
  const messageCount = root.querySelector('[data-merowen-tapestry-product-contact-message-count]');
  const submit = root.querySelector('[data-merowen-tapestry-product-contact-submit]');
  const submitLabel = root.querySelector('[data-merowen-tapestry-product-contact-submit-label]');
  const success = root.querySelector('[data-merowen-tapestry-product-contact-success]');

  if (!form) return;

  const updateError = (input) => {
    const field = input.closest('.merowen-tapestry-product__contact-field');
    const error = field?.querySelector('[data-merowen-tapestry-product-contact-error]');
    if (!error) return;

    const invalid = !input.validity.valid;
    error.textContent = invalid ? input.validationMessage : '';
    error.classList.toggle('is-visible', invalid);

    if (invalid) input.setAttribute('aria-invalid', 'true');
    else input.removeAttribute('aria-invalid');
  };

  const restoreSubmit = () => {
    if (!submit) return;
    submit.disabled = false;
    submit.removeAttribute('aria-disabled');
    submit.removeAttribute('aria-busy');
    if (submitLabel) submitLabel.textContent = submit.dataset.defaultLabel || 'SEND MESSAGE';
  };

  const updateMessageCount = () => {
    if (!message || !messageCount) return;
    messageCount.textContent = `${message.value.length} / ${message.maxLength}`;
  };

  const onInvalid = (event) => {
    if (!event.target.matches('[data-merowen-tapestry-product-contact-input]')) return;
    updateError(event.target);
  };

  const onInput = (event) => {
    if (!event.target.matches('[data-merowen-tapestry-product-contact-input]')) return;
    updateError(event.target);
    if (event.target === message) updateMessageCount();
  };

  const onSubmit = () => {
    if (!form.checkValidity() || !submit) return;
    submit.disabled = true;
    submit.setAttribute('aria-disabled', 'true');
    submit.setAttribute('aria-busy', 'true');
    if (submitLabel) {
      submitLabel.textContent = submit.dataset.submittingLabel || 'SENDING...';
    }
  };

  const onPageShow = () => restoreSubmit();

  form.addEventListener('invalid', onInvalid, true);
  form.addEventListener('input', onInput);
  form.addEventListener('submit', onSubmit);
  const onReset = () => {
    restoreSubmit();
    requestAnimationFrame(updateMessageCount);
  };

  form.addEventListener('reset', onReset);
  window.addEventListener('pageshow', onPageShow);

  if (message?.value) {
    message.value = message.value.slice(0, message.maxLength);
  }
  updateMessageCount();

  if (success) requestAnimationFrame(() => success.focus());

  TAPESTRY_CONTACT_INSTANCES.set(root, () => {
    form.removeEventListener('invalid', onInvalid, true);
    form.removeEventListener('input', onInput);
    form.removeEventListener('submit', onSubmit);
    form.removeEventListener('reset', onReset);
    window.removeEventListener('pageshow', onPageShow);
    TAPESTRY_CONTACT_INSTANCES.delete(root);
  });
}

function initTapestryWithin(scope = document) {
  markTapestryAssetsReady(scope);

  const page = scope.matches?.(TAPESTRY_TEMPLATE_SELECTOR)
    ? scope
    : scope.querySelector?.(TAPESTRY_TEMPLATE_SELECTOR);
  const searchRoot = page || scope;

  if (searchRoot.matches?.(TAPESTRY_CONTACT_SELECTOR)) {
    initTapestryContact(searchRoot);
  }
  searchRoot.querySelectorAll?.(TAPESTRY_CONTACT_SELECTOR).forEach(initTapestryContact);
}

function destroyTapestryWithin(scope) {
  if (!scope) return;

  const roots = scope.matches?.(TAPESTRY_CONTACT_SELECTOR)
    ? [scope]
    : Array.from(scope.querySelectorAll?.(TAPESTRY_CONTACT_SELECTOR) || []);

  roots.forEach((root) => TAPESTRY_CONTACT_INSTANCES.get(root)?.());
}

initTapestryWithin();

document.addEventListener('shopify:section:load', (event) => {
  initTapestryWithin(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  destroyTapestryWithin(event.target);
});

document.addEventListener('shopify:block:select', (event) => {
  const contact = event.target?.closest?.(TAPESTRY_CONTACT_SELECTOR);
  if (!contact) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  event.target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
});

